import type { NotifyPort } from '@/features/messages/domain/notify'
import type { MemberPort, TeamMember } from '../domain/member'

const getMember = async (port: MemberPort, id: string, notify: NotifyPort): Promise<TeamMember | null> => {
	try {
		return await port.getById(id)
	} catch {
		notify.error('hr.memberLoadFailed')
		throw new Error('Failed to load team member.')
	}
}

export { getMember }
